import { NgModule } from '@angular/core';
import { AegButtonComponent } from '../aeg-button.component';
import { AegButtonTypeDirective } from './aeg-button-type.directive';

@NgModule({
  declarations: [
    AegButtonComponent,
    AegButtonTypeDirective
  ],
  exports: [
    AegButtonComponent,
    AegButtonTypeDirective
  ]
})
export class AegButtonModule { }